<template>
  <b-modal
    id="add-folder-modal"
    ref="modal"
    centered
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Create')"
    :title="$t('Add') + ' ' + $t('a') + ' ' + $t('operation.dossier')"
    cancel-variant="outline-primary"
    @hidden="resetModal"
    @ok="handleOk"
    @show="resetModal">

    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        :invalid-feedback="name.invalidFeedback"
        :label="$t('Folder.Name')"
        :state="name.state"
        label-for="name-input">
        <b-form-input
          id="name-input"
          v-model="name.value"
          :state="name.state"
          type="text"
          required>
        </b-form-input>
      </b-form-group>

    </form>
  </b-modal>
</template>

<script>
import api from '../../../services/api'

export default {

  name: 'AddFolderModal',
  props: {
    operationId: {
      default: false
    }
  },

  data: function () {
    return {
      name: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  methods: {

    resetModal() {
      this.name.value = null
      this.name.state = null
      this.name.invalidFeedback = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('operationId', this.operationId)
      formData.append('name', this.name.value.trim())

      api({
        method: 'POST',
        url: `/operationDocument/addFolder`,
        data: formData
      })
        .then(() => {
          this.$emit('didAddFolder')
          this.successToast()
          this.resetModal()
          this.hideModal()
        })
        .catch(() => {
          this.errorToast()
        })
    },

    hideModal() {
      this.$bvModal.hide('add-folder-modal')
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }

      return true
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('AddFolder.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('AddFolder.error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/operation/components/AddFolderModal.vue